
export enum AuthStatus {
  In = 'in',
  Out = 'out',
  Loading = 'loading',
}
